"use client";
import { useTranslations } from "next-intl";
import React from 'react';

const ReturnPolicy = () => {
  const t = useTranslations("returns");
  return (
    <section className="bg-pink mt-4">
      <div className="max-w-[800px] mx-auto py-[35px] px-[20px]">
        <h2 className="text-[44px] text-center font-bold mb-[35px]">{t("title")}</h2>
        <div className="text-[16px] space-y-[30px]" dangerouslySetInnerHTML={{ __html: t.raw("content") }}></div>
      </div>
    </section>
  );
};

export default ReturnPolicy;
